import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

export const addRetailApplication = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.ADD_RETAIL_APPLICATION,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const updateRetailApplication = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_RETAIL_APPLICATION,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getRetailApplicationById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_RETAIL_APPLICATION_BY_ID}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const getRetailApplicationByEventAndUserId = async (eventId, userId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_RETAIL_APPLICATION_BY_EVENT_AND_USERID}?eventId=${eventId}&userId=${userId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getRetailApplicationByPitchAndUserId = async (
  pitchId,
  userId,
  traderPitchId
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_RETAIL_APPLICATION_BY_PITCH_AND_USERID}?pitchId=${pitchId}&userId=${userId}&traderPitchId=${traderPitchId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getMyApplicationsForTraderRetailers = async (userId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_MY_RETAIL_APPLICATIONS_BY_USERID}?TraderId=${userId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getRetailApplicationPaymentById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      // apiendpoints.GET_RETAIL_APP_PAY_DETLS_BY_ID,
      // data
      `${apiendpoints.GET_RETAIL_APP_PAY_DETLS_BY_ID}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const updateRetailApplicationStatus = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_RETAIL_APPLICATION_STATUS,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
export const AddEditPitchAllocation = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.ADD_EDIT_PITCH_ALLOCATION,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const updateRetailApplicationDocs = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.UPDATE_RETAIL_APP_DOCUMENT,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getRetailApplicationDocuments = async (appId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_RETAIL_APP_DOCS}?appId=${appId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getRetailApplicationPitchStatus = async (appId, pitchId) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_RETAIL_AVAILABLE_PITCH_STATUS}?appId=${appId}&pitchId=${pitchId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const rebidRetailApplication = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.RETAIL_APPLICATION_REBID,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
//
